import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 pt-14 md:pt-20 pb-6 md:pb-8">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <Link to="/" className="inline-block cursor-pointer">
            <span className="font-heading text-4xl md:text-6xl font-bold text-background-50 tracking-tight">
              The<span className="italic font-normal">Vertex</span>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-5">
            <p className="text-sm text-foreground-300 leading-relaxed max-w-sm">
              Independent journalism for the curious mind. We publish in-depth stories at the intersection of technology, business, design, and culture.
            </p>
            <div className="flex items-center gap-3 mt-5">
              {['ri-twitter-x-line', 'ri-linkedin-line', 'ri-instagram-line', 'ri-youtube-line'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-8 h-8 rounded-full border border-foreground-700 flex items-center justify-center text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer"
                  aria-label={`Social media ${icon}`}
                  rel="nofollow"
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs font-label font-medium tracking-wider uppercase text-foreground-500 mb-4">
              Contact
            </p>
            <div className="space-y-4 text-sm text-foreground-300">
              <p>244 Madison Avenue<br />New York, NY 10016</p>
              <p>+1 (212) 555-0192</p>
              <p>hello@cg91.cn</p>
            </div>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs font-label font-medium tracking-wider uppercase text-foreground-500 mb-4">
              Categories
            </p>
            <div className="grid grid-cols-2 gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer py-1"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 md:mt-16 pt-5 md:pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} The Vertex. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">Privacy Policy</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">Terms of Service</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">Accessibility</a>
          </div>
        </div>
      </div>
    </footer>
  );
}